/**
 * Trace Inspector React Hook
 *
 * React hook to subscribe to trace updates and access trace inspector methods.
 */

import { useEffect, useState } from "react";
import { traceInspector } from "./trace-inspector";
import type { MachineTrace } from "./types";

/**
 * Hook to subscribe to trace updates
 */
export function useTraceInspector() {
  const [trace, setTrace] = useState<MachineTrace | null>(
    traceInspector.getTrace(),
  );

  useEffect(() => {
    return traceInspector.subscribe(setTrace);
  }, []);

  return {
    trace,
    events: trace?.events ?? [],
    startTrace: traceInspector.startTrace.bind(traceInspector),
    endTrace: traceInspector.endTrace.bind(traceInspector),
    clearTrace: traceInspector.clearTrace.bind(traceInspector),
    exportAsJSON: traceInspector.exportAsJSON.bind(traceInspector),
    downloadTrace: traceInspector.downloadTrace.bind(traceInspector),
    addUIHint: traceInspector.addUIHint.bind(traceInspector),
    inspect: traceInspector.inspect,
  };
}
